import type { ComparedTransfer } from "./types"

export const normalizeScore = (score: number): number => {
  const normalized = typeof score === "number" ? (score <= 1 ? score * 100 : score) : 0
  return Math.min(Math.max(Math.round(normalized), 0), 100)
}

export const calculateTotalScore = (transfer: ComparedTransfer): number => {
  if (!transfer.scores) return 0

  const { scores } = transfer

  const normalizedScores = {
    identifier: normalizeScore(scores.identifier),
    amount: normalizeScore(scores.amount),
    time: normalizeScore(scores.time),
  }

  return Math.round(normalizedScores.identifier * 0.4 + normalizedScores.amount * 0.4 + normalizedScores.time * 0.2)
}

export const sortTransfers = (transfers: ComparedTransfer[], matchedTransferId?: number): ComparedTransfer[] => {
  return [...transfers].sort((a, b) => {
    // If there's a matching transferId, put it first
    if (a.id === matchedTransferId) return -1
    if (b.id === matchedTransferId) return 1

    // Sort by score from highest to lowest
    const scoreA = calculateTotalScore(a)
    const scoreB = calculateTotalScore(b)
    return scoreB - scoreA
  })
}

